export default __webpack_public_path__ + "static/media/Martinez.2bbdf29b.jpg";